import Card from './Card.vue';
import { NAME } from './constants';

export const DokladyOstatni = {
	name: NAME,
	components: {
		Card,
	},
};
